import { isPast, secondsToMilliseconds } from 'date-fns';

import { RBProgram } from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import getCorrectProgramStartAndEndTime from 'utils/getCorrectProgramStartAndEndTime';

import findCatchupTechnical from './findCatchupTechnical';

function isCatchupDetails(
    program: RBProgram | VodEditorial | RecordingMetadata,
) {
    const { programEndTime } = getCorrectProgramStartAndEndTime(program);
    const technicals =
        (program as VodEditorial).technicals ||
        (program as RBProgram).editorial?.technicals;

    return (
        programEndTime &&
        isPast(secondsToMilliseconds(programEndTime)) &&
        findCatchupTechnical(technicals)
    );
}

export default isCatchupDetails;
